module.exports = __webpack_public_path__ + "img/goodcase05.2252d38c.png";